/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./LicenseBilling.css";

import React from "react";

import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { LicenseBillingProps, LicenseBillingState } from "./LicenseBilling.types";


class PaymentMethods extends React.Component<LicenseBillingProps, LicenseBillingState> {

   /*
   constructor(props: LicenseBillingProps) {
      super(props);
   }

   public componentDidMount(): void {
   }

   public componentWillUnmount(): void {
   }

   public componentDidUpdate(prevProps: LicenseBillingProps, prevState: LicenseBillingState) {
   }
   */

   public render(): React.ReactNode {

      return (

         <>
            <h1>Payment methods</h1>
         </>

      )

   }

}


const mapStateToProps = (state: {
   sliceName: any, // redux state interface
}) => {
   return state;
}


const mapDispatchToProps = (dispatch: Dispatch) => {

   return {
      actions: bindActionCreators(
         Object.assign(
            {},
            // slice.actions
         ),
         dispatch
      )
   }

}

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(PaymentMethods);